import { FC } from "react";
import "./style.scss";

interface IUniversityProgramsCard {
  name: string;
  img: string;
  universityCardName: string;
  setUniversityCardName: (id: string) => void;
}

const UniversityProgramsCardDesk: FC<IUniversityProgramsCard> = ({ name, img, universityCardName, setUniversityCardName }) => {
  return (
    <div
      className={`university-programs-card ${universityCardName === name ? "active" : ""}`}
      onClick={() => {
        console.log(name, "name");
        setUniversityCardName(name);
      }}
    >
      <div className="university-programs-card-content">
        <div className="university-programs-card-img">
          <img src={img} alt="Img" />
        </div>
        <div className="university-programs-card-name">
          <p>{name}</p>
        </div>
      </div>
    </div>
  );
};

export default UniversityProgramsCardDesk;
